const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const COUNTRY_POPUP_STORAGE_KEY = 'ecoatm_country_choice';

// ecoatm.com and ecoatm.ca don't share localStorage, so a country choice made on one site is
// carried to the other as this URL parameter and saved on arrival (see country-suggestion-modal.js).
const COUNTRY_CHOICE_URL_PARAM = 'country_choice';
